import { Save, Search } from "@mui/icons-material";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import useApi from "_api/index";
import TableData from "components/Car/Table";
import ChipCustomize from "components/Chip";
import {
  GradientButton,
  GradientButtonOutline,
} from "components/GradientButton";
import CustomPagination from "components/TableExplanded/Pagination";
import { useCarStatuses } from "contexts/CarStatusContext";
import { useEffect, useState } from "react";
import { formatDateTime } from "utils/helpers/format";

const InventoryCars = () => {
  const { carStatuses } = useCarStatuses();
  const [filter, setFilter] = useState({
    search: "",
  });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);

  const fetchData = async (isClear = false) => {
    setLoading(true);
    try {
      //
      const response = await useApi.car_report.getInventoryCars({
        page: pagination.page,
        limit: pagination.limit,
        ...(!isClear && filter),
      });
      if (response.isStatus || response.success) {
        const { data, limit, page, total } = response;
        setDatas(data ?? []);
        setPagination({
          page: page || 1,
          limit: limit || 10,
          total: total || 0,
          totalPages: Math.ceil(total / limit) || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching inventory cars:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.page, pagination.limit]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography component={"div"} sx={{ fontSize: "32px" }}>
          ทรัพย์คงคลัง
        </Typography>
        <GradientButton
          sx={{
            px: 3,
            display: "flex",
            alignItems: "center",
            height: "48px",
          }}
          endIcon={<Save fontSize="medium" />}
        >
          ส่งออก Excel
        </GradientButton>
      </Box>

      <Grid
        container
        spacing={2}
        alignContent="flex-end"
        justifyContent="flex-end"
      >
        <Grid item xs={12} sm={6} md={4}>
          <Grid container alignItems="center" spacing={1}>
            <Grid item xs={4} textAlign="right">
              <Typography
                sx={{
                  fontSize: "16px",
                  whiteSpace: "nowrap",
                }}
              >
                ค้นหาทั้งหมด
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="ค้นหาทั้งหมด"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    bgcolor: "white",
                    height: "40px",
                  },
                }}
                value={filter.search}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Box
            sx={{
              display: "flex",
              direction: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <GradientButtonOutline
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "40px",
              }}
              onClick={() => {
                setFilter({ search: "" });
                setPagination((prev) => ({ ...prev, page: 1 }));
                fetchData(true);
              }}
            >
              ล้าง
            </GradientButtonOutline>
            <GradientButton
              sx={{
                px: 3,
                display: "flex",
                alignItems: "center",
                height: "40px",
              }}
              endIcon={<Search />}
              onClick={() => {
                fetchData();
              }}
            >
              ค้นหา
            </GradientButton>
          </Box>
        </Grid>
      </Grid>

      <TableData
        data={datas}
        loading={loading}
        columns={[
          { key: "car_picture", label: "รูปภาพ" },
          { key: "car_code", label: "รหัสรถ" },
          { key: "license_plate", label: "ทะเบียนรถ" },
          { key: "car_brand", label: "ยี่ห้อ" },
          { key: "car_price", label: "ราคาทุน" },
          {
            key: "created_date",
            label: "วันที่นำเข้า",
            render: (row) => formatDateTime(row.created_date),
          },
          {
            key: "car_status_id",
            label: "สถานะ",
            render: (row) => (
              <ChipCustomize
                label={
                  carStatuses.find((status) => status.id === row.car_status_id)
                    ?.name || "-"
                }
                status={
                  carStatuses.find((status) => status.id === row.car_status_id)
                    ?.name
                }
              />
            ),
          },
        ]}
      />

      <CustomPagination
        page={pagination.page - 1}
        rowsPerPage={pagination.limit}
        totalPage={pagination.totalPages}
        onPageChange={(_, newPage) =>
          setPagination((prev) => ({ ...prev, page: newPage + 1 }))
        }
        onRowsPerPageChange={(event) =>
          setPagination((prev) => ({
            ...prev,
            limit: parseInt(event.target.value, 10),
            page: 1,
          }))
        }
      />
    </Box>
  );
};
export default InventoryCars;
